import { Box, SelectChangeEvent } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BriaDropDown, {
	BriaDropDownProps,
	DropDownItem,
} from "../../../../../../components/common/BriaDropDown/BriaDropDown";
import RouterConstants from "../../../../../../constants/RouterConstants";
import iframeStore from "../../../../../IframeNew/iframe-store";
import { TgModel } from "../../../store/tg-model-store";
import styles from "./NewTgDropdown.module.scss";
import useTgDropdown from "./useTgDropdown";

type Props = Omit<BriaDropDownProps<string>, "onChange" | "items"> & {
	onChange: (e: SelectChangeEvent<string>, item: DropDownItem<string, TgModel>) => void;
};

const NewTgDropdown = ({ value, onChange, loading, ...rest }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "newTg.app.image.config.models" });
	const { createDropdownItems, loadingCreateItems } = useTgDropdown();
	const [localItems, setLocalItems] = useState<DropDownItem<string, TgModel>[]>([]);
	const [localValue, setLocalValue] = useState(value);
	const [searchValue, setSearchValue] = useState("");

	const filteredItems = localItems.filter(
		(item) =>
			item.key.toLowerCase().includes(searchValue.toLowerCase()) ||
			item.extraData?.description.toLowerCase().includes(searchValue.toLowerCase()) ||
			item.value.toString().includes(searchValue),
	);

	useEffect(() => {
		(async () => {
			setLocalItems(await createDropdownItems());
		})();
	}, []);

	const handleChange = (e: SelectChangeEvent<string>) => {
		setLocalValue(e.target.value);
		onChange?.(e, filteredItems.find((item) => item.value === e.target.value) as any);
	};

	const handleTrainButtonClick = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		window.open(RouterConstants.NEW_TG.PROJECTS.fullPath);
	};

	return (
		<BriaDropDown
			placeholder={t("placeholder")}
			value={value || localValue}
			onChange={handleChange}
			searchValue={searchValue}
			onSearchChange={(e) => setSearchValue(e.target.value)}
			loading={loadingCreateItems || loading}
			searchable
			debounceSearch
			searchIcon
			SearchPlaceholder={t("searchPlaceholder")}
			menuMaxHeight="70%"
			menuMaxWidth="0px"
			endStickyItem={
				!iframeStore.isIframe() && (
					<Box onClick={handleTrainButtonClick} className={styles.trainModelBtn}>
						{t("trainModelBtn")}
					</Box>
				)
			}
			{...rest}
			items={filteredItems}
		/>
	);
};

export default observer(NewTgDropdown);
